import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import './Cadance.css';

const Cadance = ({ userInfo, movementId, hourCount }) => {
  const [dayCount, setDayCount] = useState(0);
  const [objHeure, setObjHeure] = useState(0);
  const [objDay, setObjDay] = useState(0);
  const [currentHourRange, setCurrentHourRange] = useState('');

  const START_HOUR_UTC = 7; // 08:00 Tunisia
  const END_HOUR_UTC = 16;  // 17:00 Tunisia

  // ===========================
  // Fetch objective
  // ===========================
  const getObjective = async () => {
    try {
      const obj = await api.getObjective(movementId);
      setObjHeure(obj[0].obj_heure);
      setObjDay(obj[0].obj_jour);
    } catch (error) {
      console.log('Failed to fetch objective', error);
    }
  };

  useEffect(() => {
    getObjective();
  }, [movementId]);

  // ===========================
  // Fetch daily cadence every hour
  // ===========================
  const getTodayDate = () => new Date().toISOString().slice(0, 10);

  useEffect(() => {
    const fetchCadence = async () => {
      try {
        const date = getTodayDate();
        const res = await api.getDailyCadance(userInfo.name, date, date, movementId);
        setDayCount(res?.totalCount || 0);
      } catch (err) {
        console.error('Error fetching daily cadence:', err);
        setDayCount(0);
      }
    };

    // Initial fetch
    fetchCadence();

    // Calculate ms until next hour
    const now = new Date();
    const msUntilNextHour =
      (60 - now.getMinutes()) * 60 * 1000 -
      now.getSeconds() * 1000 -
      now.getMilliseconds();

    const timeoutId = setTimeout(() => {
      fetchCadence(); // fetch at start of next hour
      const intervalId = setInterval(fetchCadence, 60 * 60 * 1000);
      return () => clearInterval(intervalId);
    }, msUntilNextHour);

    return () => clearTimeout(timeoutId);
  }, [userInfo.name, movementId]);

  // ===========================
  // Update current hour range display
  // ===========================
  useEffect(() => {
    const updateHourRange = () => {
      const now = new Date();
      const hourUTC = now.getUTCHours();
      const displayHour = Math.max(START_HOUR_UTC, Math.min(hourUTC, END_HOUR_UTC));
      
      const startDisplay = `${displayHour + 1 < 10 ? '0' : ''}${displayHour + 1}:00`;
      const endDisplay = `${displayHour + 2 < 10 ? '0' : ''}${displayHour + 2}:00`;
      setCurrentHourRange(`${startDisplay} - ${endDisplay}`);
    };

    updateHourRange();
    const intervalId = setInterval(updateHourRange, 1000);
    return () => clearInterval(intervalId);
  }, []);

  // ===========================
  // Render
  // ===========================
  return (
    <div className="cadance-container">
      <table className="cadance-table">
        <tbody>
          <tr>
            <td>Hour :</td>
            <td>{currentHourRange}</td>
            <td>{hourCount} / {objHeure}</td>
          </tr>
          <tr>
            <td>Day :</td>
            <td>{getTodayDate()}</td>
            <td>{dayCount} / {objDay}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Cadance;
